export const selectWorkshopTypes = (state) => state.worshopTypes;
